import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Check, RefreshCw, WifiOff } from 'lucide-react';
import { getApiHeaders } from '../../../utils/apiHelpers';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/gestione/haccp/temperature-da-scrivere`;

const Riga = ({ r, onSalvata, onFuoriRange }) => {
  const [valore, setValore] = useState('');
  const [busy, setBusy] = useState(false);
  const salva = async () => {
    const t = parseFloat(valore.replace(',', '.'));
    if (Number.isNaN(t)) { toast.error('Scrivi la temperatura che leggi sul display'); return; }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/${r.id}`, { temperatura: t }, { headers: getApiHeaders() });
      if (data.in_range) toast.success(`${r.frigorifero_nome}: ${data.temperatura}°C scritta nel registro`);
      else toast.error(`${r.frigorifero_nome}: ${data.temperatura}°C è fuori range, controlla il frigo e scrivi l'azione correttiva`,
        { duration: 15000, action: { label: 'Azione correttiva', onClick: () => onFuoriRange(data.registrazione) } });
      onSalvata();
    } catch (e) { toast.error(e.response?.data?.detail || 'Temperatura non salvata'); }
    finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl bg-slate-900/40 lg:bg-white border border-amber-500/30 lg:border-amber-200 p-2.5" data-testid={`da-scrivere-${r.id}`}>
      <div className="flex-1 min-w-[140px]">
        <p className="text-sm font-semibold text-white lg:text-gray-900">{r.frigorifero_nome}</p>
        {r.temp_min != null && <p className="text-xs text-slate-400 lg:text-gray-500">Range {r.temp_min}°C / {r.temp_max}°C</p>}
      </div>
      <div className="flex items-center gap-1.5">
        <input value={valore} onChange={(e) => setValore(e.target.value)} inputMode="decimal" placeholder="es. 3,5" aria-label={`Temperatura ${r.frigorifero_nome}`}
          className="w-24 h-11 px-3 rounded-xl bg-slate-800 lg:bg-white border border-slate-600 lg:border-gray-300 text-white lg:text-gray-900 text-base" data-testid={`da-scrivere-${r.id}-input`} />
        <span className="text-sm text-slate-300 lg:text-gray-600">°C</span>
        <button onClick={salva} disabled={busy || !valore.trim()} className="h-11 px-4 rounded-xl bg-amber-500 hover:bg-amber-600 disabled:opacity-50 text-slate-950 text-sm font-semibold flex items-center gap-1.5 transition-colors"
          data-testid={`da-scrivere-${r.id}-salva`}>
          {busy ? <RefreshCw className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4" />}Salva
        </button>
      </div>
    </div>
  );
};

// Sensore che non risponde (scelta utente): si scrive la temperatura letta sul display, solo per oggi
export const TemperatureDaScrivere = ({ onSalvata, onFuoriRange, segnale }) => {
  const [righe, setRighe] = useState([]);
  const carica = useCallback(() => {
    axios.get(API, { headers: getApiHeaders() }).then(({ data }) => setRighe(data.righe || [])).catch(() => setRighe([]));
  }, []);
  useEffect(() => { carica(); }, [carica, segnale]);
  if (!righe.length) return null;
  return (
    <div className="rounded-2xl border border-amber-500/40 lg:border-amber-300 bg-amber-500/10 lg:bg-amber-50 p-3 space-y-2" data-testid="temperature-da-scrivere">
      <div className="flex items-start gap-2">
        <WifiOff className="h-5 w-5 text-amber-400 lg:text-amber-600 shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-bold text-white lg:text-gray-900">Il sensore non risponde: scrivi la temperatura del display</p>
          <p className="text-xs text-slate-300 lg:text-gray-600">Così il registro di oggi è completo. Nel registro resta scritto che è stata letta sul display, da chi e a che ora.</p>
        </div>
      </div>
      {righe.map((r) => <Riga key={r.id} r={r} onFuoriRange={onFuoriRange} onSalvata={() => { carica(); onSalvata(); }} />)}
    </div>
  );
};
